import React from 'react';
import { StyleSheet, ViewProps, StyleProp, ViewStyle, View } from 'react-native';
import AppTheme from '../../shared/utils/Theme';

const SafeAreaView = (props: ViewProps & { fullScreen?:boolean }) => {

    const appTheme: AppTheme = new AppTheme();
    const top = appTheme.topInsets;
    const bottom = appTheme.bottomInsets;
    const { style, fullScreen = false } = props;

    let specificStyle: StyleProp<ViewStyle> = {
        marginTop:0,
        marginBottom:0
    };
    if (fullScreen === true) {
        specificStyle.marginTop = -top;
        specificStyle.marginBottom = -bottom;
    }

    const safeAeraViewStyle: StyleProp<ViewStyle> = [style, specificStyle];
    return (
        <View {...props} style={safeAeraViewStyle}>
            {props.children}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        width: '100%',
        alignItems: "center",
        marginBottom: 10
    },
    label: {
        fontSize: 16,
        color: 'gray',
        marginBottom: 5,
    },
    input: {
        width: '90%',
        height: 50,
        padding: 10,
        borderWidth: 1,
        borderColor: 'lightgray',
        fontSize: 16,
        borderRadius: 25
    },
});

export default SafeAreaView;
